import { useState, useEffect } from 'react';
import { IS_SERVER } from '../constants';
import { useResize } from './resize';

// determine if we are in fullscreen mode and why
// don't set any state in here as called on init too
export function isFullScreenElement(el) {
  if (el && el.current) {
    return Boolean(document.fullscreenElement === el.current || document.mozFullScreenElement === el.current || document.webkitFullscreenElement === el.current || document.msFullscreenElement === el.current);
  }

  return Boolean(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen || document.fullScreenMode);
}

export function useFullScreen() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var fsEl = options && options.element;
  var initialState = IS_SERVER ? false : isFullScreenElement(fsEl);

  var _useState = useState(initialState),
      fullScreen = _useState[0],
      setFullScreen = _useState[1];

  // access various open fullscreen methods


  function openFullScreen() {
    var el = fsEl && fsEl.current || document.documentElement;

    if (el.requestFullscreen) return el.requestFullscreen();
    if (el.mozRequestFullScreen) return el.mozRequestFullScreen();
    if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
    if (el.msRequestFullscreen) return el.msRequestFullscreen();
  }

  // access various exit fullscreen methods
  function closeFullScreen() {
    if (document.exitFullscreen) return document.exitFullscreen();
    if (document.mozCancelFullScreen) return document.mozCancelFullScreen();
    if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
    if (document.msExitFullscreen) return document.msExitFullscreen();
  }

  useEffect(function () {
    function handleChange() {
      setFullScreen(isFullScreenElement(fsEl));
    }

    document.addEventListener('webkitfullscreenchange', handleChange, false);
    document.addEventListener('mozfullscreenchange', handleChange, false);
    document.addEventListener('msfullscreenchange', handleChange, false);
    document.addEventListener('MSFullscreenChange', handleChange, false); // IE11
    document.addEventListener('fullscreenchange', handleChange, false);

    return function () {
      document.removeEventListener('webkitfullscreenchange', handleChange);
      document.removeEventListener('mozfullscreenchange', handleChange);
      document.removeEventListener('msfullscreenchange', handleChange);
      document.removeEventListener('MSFullscreenChange', handleChange);
      document.removeEventListener('fullscreenchange', handleChange);
    };
  }, [options.element, fsEl]);

  return {
    fullScreen: fullScreen,
    open: openFullScreen,
    close: closeFullScreen,
    toggle: fullScreen ? closeFullScreen : openFullScreen
  };
}

export function getSizeInfo() {
  if (IS_SERVER) return {};
  return {
    screenTop: window.screenTop,
    screenY: window.screenY,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  };
}

export function isFullScreenSize(sizeInfo) {
  if (sizeInfo.screenWidth === sizeInfo.innerWidth && sizeInfo.screenHeight === sizeInfo.innerHeight) {
    return true;
  } else if (!sizeInfo.screenTop && !sizeInfo.screenY) {
    return true;
  }

  return false;
}

export function useFullScreenBrowser() {
  var size = useResize();
  var initialSizeInfo = getSizeInfo();

  var _useState2 = useState(IS_SERVER ? false : isFullScreenSize(initialSizeInfo)),
      fullScreen = _useState2[0],
      setFullScreen = _useState2[1];

  var _useState3 = useState(initialSizeInfo),
      sizeInfo = _useState3[0],
      setSizeInfo = _useState3[1];

  useEffect(function () {
    var sizeInfo = getSizeInfo();
    setFullScreen(isFullScreenSize(sizeInfo));
    setSizeInfo(sizeInfo);
  }, [size.width, size.height]);

  return {
    fullScreen: fullScreen,
    info: sizeInfo
  };
}